export class ClientArtifact
{
    public readonly type:string;
    public readonly packageOrganization:string;
    public readonly packageName:string;
    public readonly packageFile:string;
    public readonly version:string;
    public readonly identifier:string;
    public readonly descriptor:string;
    public readonly name:string;
    public readonly description:string;
    public readonly scope:string;

    constructor(json:any)
    {
        this.type = json['type'];
        this.packageOrganization = json['packageOrganization'];
        this.packageName = json['packageName'];
        this.packageFile = json['packageFile'];
        this.version = json['version'];
        this.identifier = json['identifier'];
        this.descriptor = json['descriptor'];
        this.name = json['name'];
        this.description = json['description'];
        this.scope = json['scope'];
    }
}
